import { useEffect, useState } from "react";
import axios from "../../../../requests/axios";
import routes from "../../../../requests/routes";
import Loader from "../../../../layouts/loader/Loader";
import UserCard from "../userCard/UserCard";
import classes from "./UserBlogs.module.scss";

export const UserBlogs = ({ record }) => {
  const wishlist = record.blogs;
  const [adminBlogs, setAdminBlogs] = useState([]);
  const [loader, setLoader] = useState(true);

  async function getBlogs() {
    try {
      const response = await axios.get(routes.getBlogs);
      setAdminBlogs(response.data.blogs);
      setLoader(false);
    } catch (err) {}
  }
  useEffect(() => {
    getBlogs();
  }, []);

  const wishIdSet = new Set(wishlist.map(String));
  const filteredBlogs = adminBlogs.filter((p) =>
    wishIdSet.has(String(p._id ?? p.id))
  );

  return (
    <>
      <div className={classes.cards}>
        {loader ? (
          <Loader color={"#F46444"} />
        ) : filteredBlogs.length > 0 ? (
          filteredBlogs.map((wl, index) => <UserCard key={index} user={wl} />)
        ) : (
          <>No Data</>
        )}
      </div>
    </>
  );
};
